import { useResizeInteraction } from '../use-resize-interaction'

type Props = {
  itemId: string
  baseSize: { w: number; h: number }
  onCommit: (size: { w: number; h: number }) => Promise<void> | void
}

// Small grab handle pinned to the bottom-right corner of a card. Visible only when its
// parent (`group`) is hovered or selected (the selection ring is the cue we lean on).
// Multi-corner / edge handles can come later — single corner covers ~90% of moodboard use.
export function ResizeHandle({ itemId, baseSize, onCommit }: Props) {
  const resize = useResizeInteraction({ itemId, baseSize, onCommit })
  return (
    <button
      type="button"
      onPointerDown={resize.onPointerDown}
      onPointerMove={resize.onPointerMove}
      onPointerUp={resize.onPointerUp}
      onPointerCancel={resize.onPointerUp}
      className="bg-primary/80 hover:bg-primary absolute -bottom-1 -right-1 z-10 h-3 w-3 cursor-se-resize rounded-sm opacity-0 transition-opacity group-hover:opacity-100"
      aria-label="Resize"
    />
  )
}
